<template>
    <el-card class="fitness-index customer-card-setting">
        <el-table
            border
            ref="tableData"
            v-if="tableData"
            :data="tableData"
            class="my-4"
            v-loading="loading"
            highlight-current-row
            @current-change="handleSelectChange"
        >
            <el-table-column prop="id" :label="$t('Common.id')" align="center" v-if="false"/>
            <el-table-column prop="createdAt" :label="$t('Card.add_time')" align="center"/>
            <el-table-column prop="storeName" :label="$t('Common.store')" align="center"/>
            <el-table-column prop="cardNumber" :label="$t('Common.card_number')" align="center"/>
            <el-table-column prop="physicalId" :label="$t('Card.phy_id')" align="center"/>
            <el-table-column prop="statusName" :label="$t('Reception.Fourth.status')" align="center" />
            <el-table-column prop="clientName" :label="$t('Card.holder')" align="center" />
            <el-table-column prop="clientPhone" :label="$t('Card.holder_phone')" align="center" />
            <el-table-column prop="lastBoundAt" :label="$t('Card.bind_time')" align="center" />
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData && tableData.length"
            class="text-right"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>

        <!-- 编辑弹窗 -->
        <el-dialog
            :title="this.id ? $t('Card.edit_member_card') : $t('Card.add_member_card')"
            :visible.sync="visible">
            <el-form
                ref="cardSetting"
                :model="cardSettingForm"
                :rules="rules"
                :status-icon="true"
                label-width="80px"
                label-suffix=" : "
                label-position="right"
                v-loading="form_loading"
            >
                <el-form-item :label="$t('Common.store')" prop="storeId">
                <el-select
                    v-model="cardSettingForm.storeId"
                    :placeholder="$t('Common.all_store2')" class="w-full" clearable>
                    <el-option
                        v-for="(item, index) in stores"
                        :key="index"
                        :label="item.name"
                        :value="item.id"
                    />
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('Common.card_number')" prop="cardNumber">
                    <el-input
                        :placeholder="$t('Fill.card_number')"
                        v-model.trim="cardSettingForm.cardNumber"/>
                </el-form-item>
                <el-form-item :label="$t('Card.phy_id')" prop="physicalId">
                    <el-input
                        :placeholder="$t('Common.click_bind_physical')"
                        v-model.trim="cardSettingForm.physicalId"/>
                </el-form-item>
                <el-form-item :label="$t('Common.remark')" prop="remark">
                    <el-input
                        :placeholder="$t('Fill.remark')"
                        type="textarea"
                        :autosize="{ minRows: 5, maxRows: 10}"
                        v-model="cardSettingForm.remark"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer"  style="text-align:center">
                <el-button type="primary" slot="footer" @click="submit">
                    {{ $t('Message.confirm') }}
                </el-button>
            </div>
        </el-dialog>
        <!-- 操作记录弹窗 -->
        <el-dialog :title="$t('Sell.operation_record')" :visible.sync="record_visible">
            <el-table :data="records" border style="width: 100%;">
                <el-table-column prop="operationTime" align="center" :label="$t('Reception.Third.time')"/>
                <el-table-column prop="operation" align="center" :label="$t('Sell.Operation_content')"/>
                <el-table-column prop="operatorName" align="center" :label="$t('Reception.Third.people')"/>
                <el-table-column prop="remark" :label="$t('Common.remark')" align="center"/>
            </el-table>
        </el-dialog>
    </el-card>
</template>

<!-- 12/26 -->
<script>
import { Dialog, DatePicker, Row } from 'element-ui';

export default {
    props: ['activeName', 'stores', 'form'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRow: Row,
    },
    data() {
        return {
            cardSettingForm: {
                storeId: null,
                cardNumber: null,
                physicalId: null,
                remark: '',
            },
            id: '',
            cardId: '',
            form_loading: false,
            record_visible: false,
            visible: false,
            loading: false,
            tableData: [],
            records: [],
            rules: {
                cardNumber: [
                    { required: true, message: this.$t('Message.Member_card_number_noempty') },
                ],
                storeId: [
                    { required: true, message: this.$t('Message.choose_your_store') },
                ],
            },
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    watch: {
        activeName(val) {
            if (val === 'cardNum') this.fetchData();
        },
        'visible'(val) {
            if (!val) this.handleReset();
        },
    },
    methods: {
        handleReset() {
            this.cardSettingForm = {
                storeId: null,
                cardNumber: null,
                physicalId: null,
                remark: '',
            };
            this.id = null;
            setTimeout(() => {
                this.$refs.cardSetting.resetFields();
            });
        },
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('card-number-setting/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                    storeIds: this.form.storeId ? this.form.storeId : null,
                },
            }).then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}条记录`;
                this.$emit('input', msg);
            })
            .finally(() => {
                this.loading = false;
            });
        },
        async handleEdit(data) {
            if (data && this.validSelect()) {
                if (this.$$filterPermission('售卖-卡号管理-添加/修改/废弃/恢复/导入/查看操作记录')) {
                    this.loading = true;
                    await API.get(`card-number-setting/${this.cardId}`)
                    .then(res => {
                        this.cardSettingForm = res;
                        this.id = res.id;
                        this.$delete(this.cardSettingForm, 'id');
                        this.visible = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            } else if (!data) {
                if (this.$$filterPermission('售卖-卡号管理-添加/修改/废弃/恢复/导入/查看操作记录'))
                    this.visible = true;
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        submit() {
            this.$refs.cardSetting.validate(valid => {
                if (!valid) return false;
                else if (this.id) this.putData();
                else this.postData();
            });
        },
        putData() {
            API.put(`card-number-setting/${this.id}`, this.cardSettingForm)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                    this.fetchData(1);
                    this.visible = false;
                })
                .finally(() => {
                    this.loading = false;
                    this.form_loading = false;
                })
                .catch(err => {
                    $ele.$message.error(err);
                });
        },
        postData() {
            API.post('card-number-setting', this.cardSettingForm)
                .then(() => {
                    $ele.$message.success(this.$t('Message.save'));
                    this.fetchData(1);
                    this.visible = false;
                })
                .finally(() => {
                    this.loading = false;
                    this.form_loading = false;
                })
                .catch(err => {
                    $ele.$message.error(err);
                });
        },
        handleDelete() {
            if (this.validSelect()) {
                $ele.$confirm(this.$t('Message.Confirm_discard'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                })
                .then(() => {
                    if (this.$$filterPermission('售卖-卡号管理-添加/修改/废弃/恢复/导入/查看操作记录')) {
                        API.delete(`card-number-setting/${this.cardId}/active`).then(() => {
                            $ele.$message.success(this.$t('Message.Discarded_success'));
                            this.fetchData();
                        });
                    } else {
                        $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                            confirmButtonText: this.$t('Message.confirm'),
                            callback: action => {},
                        });
                    }
                })
                .catch(() => {
                    $ele.$message.info(this.$t('Message.Cancelled'));
                });
            }
        },
        handleRestore() {
            if (this.validSelect()) {
                $ele.$confirm(this.$t('Message.Confirm_to_restore'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                }).then(() => {
                    if (this.$$filterPermission('售卖-卡号管理-添加/修改/废弃/恢复/导入/查看操作记录')) {
                        API.put(`card-number-setting/${this.cardId}/active`).then(() => {
                            $ele.$message.success(this.$t('Common.message.successRestore'));
                            this.fetchData();
                        });
                    } else {
                        $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                            confirmButtonText: this.$t('Message.confirm'),
                            callback: action => {},
                        });
                    }
                }).catch(() => {
                    $ele.$message.info(this.$t('Common.message.cancelRestore'));
                });
            }
        },
        seeRecord() {
            if (this.validSelect()) {
                if (this.$$filterPermission('售卖-卡号管理-添加/修改/废弃/恢复/导入/查看操作记录')) {
                    this.loading = true;
                    API.get(`card-number-setting/${this.cardId}/log`)
                    .then(res => {
                        this.records = res;
                        this.record_visible = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        handleSelectChange(val) {
            this.cardId = val ? val.id : '';
        },
        validSelect() {
            if (!this.cardId) $ele.$message.warning(this.$t('Message.Please_select_a_data'));
            else return true;
        },
        flush(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('card-number-setting/pages', {
                params: {
                    ...this.pagination,
                },
            })
            .then(res => {
                this.tableData = res.content;
                this.pagination.total = res.totalElements;
                const msg = `${this.$t('Charge.search')}：共${res.totalElements}条记录`;
                this.$emit('input', msg);
            })
            .finally(() => {
                this.loading = false;
            });
        },
    },
    created() {
        if (this.activeName === 'cardNum') this.fetchData();
    },
};
</script>
<style lang="scss">
.customer-card-setting {
    .el-dialog {
        width: 540px;
    }
    .el-dialog--center .el-dialog__body {
        padding: 25px 25px 0;
    }
    .el-dialog__body {
        height: 50vh;
        overflow: auto;
    }
    .icon {
        position: absolute !important;
        right: 0px;
        display: inline;
    }
    .title-3a {
        height: 20px;
        color: grey;
        line-height: 10px;
        font-size: 12px;
        font-weight: 400;
    }
}
</style>
